import Model from './BaseModel';
import AdminUser from './AdminUser';

export default class BetAdjustment extends Model {
	resourceName() {
		return 'bet_adjustment';
	}

	fields() {
		return ['amount', 'bet_id', 'created_at', 'note', 'transaction_id'];
	}

	relationships() {
		return {
			admin_user: new AdminUser()
		};
	}

	adjustment(data) {
		return this.makePersistRequest({
			url: this.resourceUrl(),
			method: 'POST',
			data
		});
	}
}
